import { combineReducers, type Reducer, type ReducersMapObject } from '@reduxjs/toolkit'

export interface ReducerManager<State extends object> {
  reduce: Reducer<State>
  add<Key extends string>(key: Key, reducer: Reducer): boolean
  has(key: string): boolean
}

export function createReducerManager<State extends object>(initialReducers: ReducersMapObject): ReducerManager<State> {
  const reducers = { ...initialReducers }
  let combinedReducer = combineReducers(reducers)
  return {
    reduce: (state: State | undefined, action: Parameters<typeof combinedReducer>[1]) => combinedReducer(state, action) as State,
    add(key: string, reducer: Reducer) {
      if (reducers[key] === reducer) return false
      reducers[key] = reducer
      combinedReducer = combineReducers(reducers)
      return true
    },
    has: (key: string) => Boolean(reducers[key]),
  }
}
